import React from 'react';
import PropTypes from 'prop-types';

import { ReactDataTable, Stack } from '@metarouter-private/mr-mui';
import NoDataText from 'app/components/data-table/NoDataText';
import changelogTableColumns from './changelogTableColumns';

const PER_PAGE = 10;

export default function Changelog({ playbooks }) {
  return (
    <Stack px={3}>
      {/* TODO - Update to use server-side pagination */}
      <ReactDataTable
        columns={changelogTableColumns}
        data={playbooks}
        noDataComponent={<NoDataText>No revisions saved yet.</NoDataText>}
        pagination
        paginationPerPage={PER_PAGE}
        defaultSortFieldId="revision"
        defaultSortAsc={false}
      />
    </Stack>
  );
}

Changelog.propTypes = {
  playbooks: PropTypes.array.isRequired,
};
